import React, { useState } from 'react';
import axios from 'axios';

const ForgotPassword = () => {
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const response = await axios.post('https://api.lbnhyderabad.com/login/forgot-password', { email });
            setMessage(response.data.message);
        } catch (error) {
            setMessage('Error: ' + error.response.data.message);
        }
        setLoading(false);
    };

    const inputStyle = {
        width: '100%',
        padding: '10px',
        borderRadius: '8px',
        border: '1px solid #ccc',
        boxSizing: 'border-box',
        fontSize: '14px',
        outline: 'none',
    };

    const inputFocusStyle = {
        ...inputStyle,
        borderColor: '#007bff',
        boxShadow: '0 0 5px rgba(0, 123, 255, 0.5)',
    };

    // Inline styles for the button
    const buttonStyle = {
        width: '100%',
        padding: '10px',
        backgroundColor: '#007bff',
        color: 'white',
        border: 'none',
        borderRadius: '8px',
        fontSize: '16px',
        cursor: 'pointer',
    };

    const buttonDisabledStyle = {
        ...buttonStyle,
        backgroundColor: '#cccccc',
        cursor: 'not-allowed',
    };

    return (
        <div style={{ width: '100%', maxWidth: '400px', margin: '0 auto', padding: '20px', boxSizing: 'border-box', borderRadius: '8px', backgroundColor: '#f9f9f9', boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)' }}>
            <h2 style={{ textAlign: 'center', marginBottom: '20px' }}>Forgot Password</h2>
            <form onSubmit={handleSubmit}>
                <div style={{ marginBottom: '15px' }}>
                    <label style={{ fontSize: '14px', fontWeight: 'bold', display: 'block', marginBottom: '5px' }}>Email:</label>
                    <input
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                        style={inputStyle}
                        onFocus={(e) => e.target.style = inputFocusStyle} 
                    />
                </div>
                <button type="submit" disabled={loading} style={loading ? buttonDisabledStyle : buttonStyle}>
                    {loading ? 'Processing...' : 'Submit'}
                </button>
            </form>
            {message && <p style={{ textAlign: 'center', marginTop: '20px', color: 'red' }}>{message}</p>}
        </div>
    );
};

export default ForgotPassword;
